import { render, staticRenderFns } from "./PharmacyExpenseChart.vue?vue&type=template&id=ef55a5d4"
import script from "./PharmacyExpenseChart.vue?vue&type=script&lang=js"
export * from "./PharmacyExpenseChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports